/**
 * Endereços de contacto mostrados aos utilizadores.
 *
 * Estavam escritos à mão em quinze sítios. Mudar um endereço obrigava a
 * procurá-lo por todo o projecto, e bastava falhar um para o site passar a
 * indicar dois endereços diferentes para a mesma coisa.
 *
 * São propósitos distintos e não devem ser fundidos: o suporte técnico e os
 * textos legais respondem a coisas diferentes, e a morada do RGPD é um
 * compromisso publicado que não se muda de ânimo leve.
 *
 * Só o suporte está aqui por agora — os restantes continuam nos textos legais
 * onde estão, para não se mexer neles sem intenção.
 */

/** Suporte técnico e comunicação de problemas. */
export const SUPPORT_EMAIL = 'mail@venue1hub.com';
